import React, { useEffect, useRef, useState } from "react";
import styles from "./recommendedAdsCarousel.scss"
import { Carousel } from "antd";
import { api, checkEmptyObject, getWindowWidth, isMobileScreen } from "../../../services";
import { SimilarAdCard } from "../../../components/SimilarAdCard";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../../routes/Auth/auth.ducks";
import { DetailI } from "../../../dataConfig/dataConfigTypes";
import { Config } from "../../../services/api";
import { ScreenSize } from "../../../models";
import ReactGA from "react-ga4";

export const RecommendedAdsCarousel = () => {
  const windowWidth = getWindowWidth()
  const isMobile = isMobileScreen(windowWidth);
  const [recommendedAds, setRecommendedAds] = useState(null)
  const userInfo = useSelector(selectUserInfo)

  const fetchRecommendedAds = async () => {
    try {
      const summary: DetailI[] = await Config.UI("summary.json");
      const response = await api.Ads.fetchRecommended();


      const newRecommendedAds = response.map(ad => {
        const summaryConfig = summary.find(c => c.name === ad.module);
        const parsedSummaryData = api.parseSummaryData(summaryConfig, ad, [])
        return parsedSummaryData
      })

      setRecommendedAds(newRecommendedAds)
    } catch (error) {
      setRecommendedAds(null)
    }
  }

  const shouldShowRecommendedAds =
    recommendedAds && recommendedAds.length > 4

  const containerRef = useRef(null);

  useEffect(() => {
    if (!shouldShowRecommendedAds) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          ReactGA.event({
            category: "Oglasi koji bi te mogli zanimati",
            action: "Click",
            label: `Prikazan widget`
          });
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [shouldShowRecommendedAds]);

  useEffect(() => {
    if (checkEmptyObject(userInfo)) {
      fetchRecommendedAds()
    };
  }, [userInfo])


  const sendGoogleEvent = () => {
    ReactGA.event({
      category: "Oglasi koji bi te mogli zanimati",
      action: "Click",
      label: `Otvaranje oglasa`
    });
  }

  if (!shouldShowRecommendedAds) return null;

  const slidesToShow = windowWidth < ScreenSize.small ? 1
    : windowWidth < ScreenSize.detailPageSwitchLayout ? 2
      : 4

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.title} style={{
        fontSize: isMobile ? 22 : 32,
        marginBottom: isMobile ? 20 : 40,
      }}>Oglasi koji bi te mogli zanimati</div>
      <Carousel
        swipe
        draggable
        slidesToShow={slidesToShow}
        slidesToScroll={slidesToShow}
        infinite={false}
        // @ts-ignore
        customPaging={() => (
          <div className={!isMobile ? styles.dot : styles.dotMobile} />
        )}
        dots
        className={`${styles.carousel}`}
      >
        {recommendedAds.map((ad: any) => (
          <div key={ad.id} className={`${styles.slide} ${recommendedAds.length === 1 ? styles.slideOnly : ""}`}>
            <SimilarAdCard
              ad={ad}
              category={ad.category}
              onClick={sendGoogleEvent}
              hasFavorite
              eventLabel={`Recommended Ads - Gallery swipe`}
              className={styles.recommendedAdsCarouselCard}

            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/HomePage/RecommendedAdsCarousel/RecommendedAdsCarousel.tsx